<template>
    <div>
        <div>
            <div class="col-xs-12" style="padding:4px;border:1px solid #ddd;background: rgba(1,1,1,0.2);">
                <div class="col-xs-12 col-md-8">
                    Law statement:
                    <input class="form-control" type="text" v-model="retObj.msg" />
                    Background:
                    <input class="form-control" type="text" v-model="retObj.style.background" />
                    Color:
                    <input class="form-control" type="text" v-model="retObj.style.color" />
                </div>
                <div class="col-xs-12 col-md-4">
                    {{retObj}}
                </div>
            </div>
        </div>
        <div><input type="button" class="btn btn-default" @click="save"  value="Done"/></div>
    </div>
</template>
<script>
    import modalX from '../components/base/ModalX.vue';

    export default {
        components: {
            modalX: modalX
        },
        props: ["shopUserId","initData"],
        data: function () {
            return {
                retObj: this.initData === null ? {
                    msg: null,
                    style: {}
                } : this.initData
            };
        },
        methods: {
            save: function () {
                this.$emit("onsave", this.retObj);
            }
        },
        created: function () {

        },
        mounted: function () {
            console.log("jsonData userid", this.shopUserId);
        },
        destroyed: function () {
        }
    }
</script>